
export const InvoicesBaseQueryKey = 'invoices';
